import { Fragment, useContext, useEffect, useState } from "react";
// @mui
import { styled } from "@mui/material/styles";
import { Typography, Container, Card, Grid } from "@mui/material";
// components
import Page from "../../components/Page";
import { MyContext } from "../../layouts/dashboard";
import BackButton from "../../components/BackButton";
import detailFields from "../../_mock/details";

// ----------------------------------------------------------------------

const ContentStyle = styled("div")(() => ({
  margin: "auto",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column"
}));

// ----------------------------------------------------------------------

const normalise = (sentence) => {
  const words = sentence.split(" ");

  return words
    .map((word) => word[0].toUpperCase() + word.substring(1))
    .join(" ");
};

export default function Details() {
  const { row } = useContext(MyContext);

  const [details, setDetails] = useState([]);

  const getStatus = (e) => {
    switch (e) {
      case 0:
        return "Not yet Complete";
      case 1:
        return "In Progress";
      case 2:
        return "Mentorship";
      case 3:
        return "Complete";
      default:
        return "NA";
    }
  };

  useEffect(() => {
    let vendorCategory = "";
    switch (row.vendor_category_id) {
      case 1: {
        vendorCategory = "auth";
        break;
      }
      case 2: {
        vendorCategory = "gym";
        break;
      }
      case 10: {
        const FORM_DETAILS = !!row.form_details
          if (FORM_DETAILS?.purpose_of_attending === "For Exposure") {
            vendorCategory = "webinar_summary";
            break;
          }
          if (FORM_DETAILS?.already_associated) {
            vendorCategory = "webinar_full_associated";
            break;
          }
          vendorCategory = "webinar_full";
          break;
      }
      default:
        vendorCategory = "auth";
    }
    setDetails(detailFields[vendorCategory]);
  }, [row]);

  return (
    <Page title="Profile">
      <Container>
        <ContentStyle>
          <BackButton />
          <Typography variant="h3" paragraph>
            Details
          </Typography>
          <Card sx={{ width: "100%", p: 2 }}>
            <Grid container spacing={0}>
              <Grid item xs={6}>
                <Typography>
                  <b>Name</b>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>{row.name}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>
                  <b>Email</b>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>{row.email}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>
                  <b>Phone</b>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>{row.phone}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>
                  <b>City</b>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>{row.city}</Typography>
              </Grid>
            </Grid>
            <br />
            <hr />
            <br />
            {row.vendor_category_id === 1 && row.status && (
              <Grid container spacing={0}>
                <Grid item xs={6}>
                  <Typography>
                    <b>Status</b>
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography>{getStatus(row.status)}</Typography>
                </Grid>
              </Grid>
            )}
            {row.form_details?.already_associated && (
              <Grid container spacing={0}>
                <Grid item xs={6}>
                  <Typography>
                    <b>Purpose of Attending</b>
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography>Business Related</Typography>
                </Grid>
              </Grid>
            )}
            <Grid container spacing={0}>
              {details.map((e, i) => (
                <Fragment key={i}>
                  <Grid item xs={6}>
                    <Typography>
                      <b>{normalise(e.replaceAll("_", " "))}</b>
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>
                      {row.form_details ? row.form_details[e] || "NA" : "NA"}
                    </Typography>
                  </Grid>
                </Fragment>
              ))}
            </Grid>
          </Card>
        </ContentStyle>
      </Container>
    </Page>
  );
}
